import { useEffect, useState
} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";



import{
    Cart,
    //EditProduct,
    Home,
    AboutUs,
    Login,
    Navbar,
    Products,
    Register,
    Users,
    Profile
} from "./";

const App = () => {
    const [users, setUsers] = useState(null);
    const [products, setProducts] = useState([]);
    const [token, setToken] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const fetchProducts = async () => {
        const response = await fetch("/api/pens");
        const { products } = await response.json();
        setProducts(products);
    };
    const fetchUser = async () => {
        const token = localStorage.getItem("token");
        let localUser = localStorage.getItem("localUser");
        setUsers(localStorage.getItem("userId"));
        if (!localUser) {
          localStorage.setItem(
            "localUser",
            JSON.stringify({
              orders: [],
              cart: { products: [] },
            })
          );
        }
        if (!token) {
          setUsers(JSON.parse(localUser));
          return;
        }
        const response = await fetch("/api/users/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const info = await response.json();
        // setUsers({ ...info.user, token });
      };
    
      useEffect(() => {
        fetchProducts();
        fetchUser();
      }, []);
    
      return (
        <>
        <BrowserRouter>
          <Navbar users={users} setUsers={setUsers} token={token} setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about_us" element={<AboutUs />} />
            <Route
              path="/products"
              element={<Products products={products} />}
            />
            <Route
              path="/cart"
              element={<Cart users={users} fetchUser={fetchUser} setUsers={setUsers} />}
            />
            <Route
              path="/products/:productId"
              element={
                <Products
                  setUsers={setUsers}
                  products={products}
                  users={users}
                  fetchUser={fetchUser}
                />
              }
            />
            <Route path="/register" element={<Register setUsers={setUsers} />} />
            <Route path="/login" element={<Login setUsers={setUsers} setToken={setToken} token={token} users={users}/>} />
            {/* <Route
              path="/admin/products"
              element={
                <AdminProducts
                  products={products}
                  users={users}
                  fetchProducts={fetchProducts}
                />
              }
            /> */}
            <Route path="/profile" element={<Profile setUsers={setUsers} setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn} setToken={setToken} token={token} users={users} />} />
            <Route path="/admin/users" element={<Users users={users} />} />
            {/* <Route
              path="/admin/products/:productId"
              element={
                <EditProduct
                  products={products}
                  user={user}
                  fetchProducts={fetchProducts}
                />
              }
            /> */}
          </Routes>
          </BrowserRouter>
        </>
      );
    };


    
    export default App;
